var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._g(_vm._b({tag:"component",staticClass:"kvass-doughnut"},'component',_vm.$attrs,false),_vm.$listeners),[(_vm.hasContent)?_c('div',{staticClass:"kvass-doughnut__content"},[_vm._t("content"),(_vm.hasCenter)?_c('div',{staticClass:"kvass-doughnut__center"},[_vm._t("center")],2):_vm._e()],2):_vm._e(),(_vm.hasDimensions)?_c('div',{class:[
      'kvass-doughnut__labels',
      _vm.direction === 'row' ? 'kvass-doughnut__labels__row' : 'kvass-doughnut__labels__column',
    ]},[_vm._t("dimensions")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }